import { useEffect } from "react";

const BLOCKED_KEYS = ["s", "u", "p"];
const MEDIA_TAGS = ["IMG", "VIDEO"];

const isField = (el) => Boolean(el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable));

const blockOutsideFields = (e) => { if (!isField(e.target)) e.preventDefault(); };

const blockMediaDrag = (e) => { if (e.target && MEDIA_TAGS.includes(e.target.tagName)) e.preventDefault(); };

const blockShortcuts = (e) => {
  const key = (e.key || "").toLowerCase();
  if ((e.ctrlKey || e.metaKey) && BLOCKED_KEYS.includes(key) && !isField(e.target)) e.preventDefault();
};

const HANDLERS = [
  ["contextmenu", blockOutsideFields],
  ["copy", blockOutsideFields],
  ["dragstart", blockMediaDrag],
  ["keydown", blockShortcuts],
];

// Deters casual copying/saving: right-click, media drag, copy and save/print shortcuts outside form fields.
export const useContentProtection = () => {
  useEffect(() => {
    HANDLERS.forEach(([evt, fn]) => document.addEventListener(evt, fn));
    return () => HANDLERS.forEach(([evt, fn]) => document.removeEventListener(evt, fn));
  }, []);
};
